import { AxiosInstance } from "./client";
import { CouponsApis } from "./endpoints";

export const getCoupons = (params) => {
  return AxiosInstance()
    .get(CouponsApis.LIST_COUPONS, { params })
    .then((response) => response?.data?.data);
};
